import React from 'react';
import Select from "react-select";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFormContext } from 'react-hook-form';
import dayjs from 'dayjs';
import { formStyles as styles } from './styles';

export default function Step1BasicInfo({
    optionsHerdsman,
    onHerdsmanChange,
    selectedHerdsman,
    selectedOrderDate,
    setSelectedOrderDate,
    selectedReceiptTime,
    setSelectedReceiptTime,
    filteredOptionsReceiptTime,
    quatityValue,
    setQuatityValue,
    phoneNumberValue,
    setPhoneNumberValue,
    isNoCookingDate,
    orderCode
}) {
    const { register, setValue, formState: { errors } } = useFormContext();

    return (
        <div>
            <div style={styles.stepHeader}>
                <svg style={styles.stepHeaderIcon} fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
                <h3 style={styles.stepHeaderTitle}><span>Thông tin cơ bản</span></h3>
            </div>

            <div className="row">
                <div className="form-group col-md-6">
                    <label style={styles.formLabel}><span>Mã đăng ký</span></label>
                    <input className="form-control" type="text" {...register("orderCode")} placeholder="Mã tự động" value={orderCode} readOnly
                        style={styles.inputReadOnly} />
                </div>
                <div className="form-group col-md-6">
                    <label style={styles.formLabel}><span>Người nhận</span> <span className='required'>*</span></label>
                    <Select isClearable
                        name="herdsManOrderId"
                        value={selectedHerdsman}
                        placeholder="Chọn người nhận" closeMenuOnSelect={true}
                        onChange={(data) => { onHerdsmanChange(data ? data.value : 0); }}
                        options={optionsHerdsman} noOptionsMessage={() => "Không tồn tại"} />
                    {errors.herdsManOrderId && errors.herdsManOrderId.type === "required" && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                </div>
            </div>

            <div className="row">
                <div className="form-group col-md-6">
                    <label style={styles.formLabel}><span>Số điện thoại</span> <span className='required'>*</span></label>
                    <input className="form-control" type="text"
                        name="phoneNumber"
                        value={phoneNumberValue || ""}
                        onChange={(data) => {
                            const value = data.target.value;
                            setPhoneNumberValue(value);
                            setValue("phoneNumber", value);
                        }} maxLength={20}
                        placeholder="Nhập số điện thoại" />
                    {errors.phoneNumber && ((errors.phoneNumber.type === "required" && (
                        <span className="error"><span>Trường này là bắt buộc</span></span>
                    )) || (errors.phoneNumber.type === 'maxLength' && (
                        <span className='error'><span>Không được quá 20 ký tự</span></span>
                    )))}
                </div>
                <div className="form-group col-md-6">
                    <label style={styles.formLabel}><span>Số lượng</span> <span className='required'>*</span></label>
                    <input
                        className="form-control"
                        type="text"
                        name="quatity"
                        value={quatityValue}
                        placeholder="Nhập số lượng"
                        onChange={(e) => {
                            const val = e.target.value.replace(/[^0-9]/g, "");
                            setQuatityValue(val);
                            setValue("quatity", val);
                        }} />
                    {errors.quatity && errors.quatity.type === "required" && (
                        <span className="error"><span>Trường này là bắt buộc</span></span>
                    )}
                    {errors.quatity && errors.quatity.type === "validate" && (
                        <span className="error"><span>Giá trị không hợp lệ</span></span>
                    )}
                </div>
            </div>

            <div className="row">
                <div className="form-group col-md-6">
                    <label style={styles.formLabel}><span>Ngày nhận</span> <span className='required'>*</span></label>
                    <DatePicker
                        name="orderDate"
                        shouldDisableDate={isNoCookingDate} disablePast
                        onChange={(data) => {
                            if (data) {
                                const formatted = dayjs(data).format();
                                setValue("orderDate", formatted, { shouldValidate: true, shouldDirty: true });
                                setSelectedOrderDate(data);
                            } else {
                                setValue("orderDate", undefined, { shouldValidate: true, shouldDirty: true });
                                setSelectedOrderDate(null);
                            }
                        }}
                        value={selectedOrderDate} className="form-control"
                        slotProps={{ textField: { size: 'small' } }} format='DD/MM/YYYY' />
                    {errors.orderDate && errors.orderDate.type === "required" && (
                        <span className="error"><span>Trường này là bắt buộc</span></span>
                    )}
                    {errors.orderDate && errors.orderDate.type === "validate" && (
                        <span className="error"><span>{errors.orderDate.message}</span></span>
                    )}
                </div>
                <div className="form-group col-md-6">
                    <label style={styles.formLabel}><span>Thời gian nhận</span> <span className='required'>*</span></label>
                    <Select
                        name="receiptTime"
                        value={selectedReceiptTime}
                        placeholder="Chọn thời gian" closeMenuOnSelect={true}
                        onChange={(data) => {
                            setSelectedReceiptTime(data);
                            setValue("receiptTime", data ? data.value : null, { shouldValidate: true, shouldDirty: true });
                        }}
                        options={filteredOptionsReceiptTime} noOptionsMessage={() => "Không tồn tại"} />
                    {errors.receiptTime && errors.receiptTime.type === "required" && (
                        <span className="error"><span>Trường này là bắt buộc</span></span>
                    )}
                </div>
            </div>
        </div>
    );
}
